import React, { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { Spin } from 'antd';

const InvoiceConfigView = lazy(() => import('./views/InvoiceConfigView'));

export const invoiceConfigRoutes: RouteObject[] = [
    {
        path: '/admin/invoice-config',
        element: (
            <Suspense fallback={<div className="flex justify-center p-8"><Spin /></div>}>
                <InvoiceConfigView />
            </Suspense>
        )
    }
];
